import { styled } from '@uhg-abyss/web/tools/styled';
import { Box } from '@uhg-abyss/web/ui/Box';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';
import { CheckboxGroup } from '@uhg-abyss/web/ui/CheckboxGroup';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Text } from '@uhg-abyss/web/ui/Text';

export const SuggestEditProviderAvatar = styled(Flex, {
  width: '48px',
  height: '48px',
  minWidth: '48px',
  minHeight: '48px',
});

export const SuggestEditProviderName = styled(Text, {
  fontWeight: 'bold',
});

export const SuggestEditProviderSpeciality = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '12.64px',
    lineHeight: '16px',
  },
});

export const SuggestEditChooseLocationContainer = styled(Flex, {
  justifyContent: 'space-between',
  flexDirection: 'column',
  width: '100%',
  height: 'fit-content',
  marginBottom: '30px',
});

export const SuggestEditNextBoxContainer = styled(Box, {
  '&.abyss-box-root': {
    Padding: '16px, 24px, 16px, 24px',
    backgroundColor: 'white',
  },
});

export const SuggestEditLocationText = styled(Text, {
  '&.abyss-text-root': {
    fontSize: '$sm',
    color: '$core.color.brand.60',
    fontWeight: '600',
    position: 'relative',
    marginTop: '$md',
  },
});
export const SuggestEditCheckBoxGroup = styled(CheckboxGroup, {
  '&.abyss-checkbox-group-root': {
    width: '100%',
  },
});

export const CheckBoxContainer = styled('div', {
  backgroundColor: '$core.color.neutral.10',
});

export const SuggestEditCheckBox = styled(Checkbox, {
  '&.abyss-checkbox-label': {
    fontSize: '$sm',
    lineHeight: '18px',
    color: '$core.color.neutral.90',
    fontWeight: '$medium',
  },
  '&.abyss-checkbox-root': {
    padding: '6px 8px',
    marginTop: 0,
  },
});
export const NextButtonSection = styled('div', {
  display: 'flex',
  gap: '4px',
  overflow: 'auto',
  direction: 'row',
  justify: 'center',
  alignItems: 'center',
  width: '100px',
  height: '42px',
});
